export default function OrderBilling({ order, handleEditShippingValue }) {
    if (!order) return null;

    return (
        <div className="table-container">
            <table className="table">
                <tbody>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Name
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.name', order.billing.name)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.name}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Address Line 1
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.address.line1', order.billing.address.line1)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.address.line1}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            City
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.address.city', order.billing.address.city)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.address.city}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            State
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.address.state', order.billing.address.state)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.address.state}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Postal Code
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.address.postal_code', order.billing.address.postal_code)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.address.postal_code}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Email
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.email', order.billing.email)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.email}
                        </td>
                    </tr>
                    <tr>
                        <td style={{ 
                            fontWeight: 'var(--font-weight-semibold)', 
                            color: 'var(--text-primary)',
                            paddingRight: 'var(--spacing-xl)',
                            minWidth: '150px'
                        }}>
                            Phone
                        </td>
                        <td
                            onDoubleClick={() => handleEditShippingValue('billing.phone', order.billing.phone)}
                            style={{ 
                                cursor: 'pointer',
                                color: 'var(--text-secondary)'
                            }}
                        >
                            {order.billing.phone}
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
}